import React, { useEffect, useRef } from 'react';
import svgBack from '../images/icones/back.svg';
import svgPlay from '../images/icones/play.svg';
import svgPause from '../images/icones/pause.svg';
import svgClose from '../images/icones/close.svg';
import { noSpecialCharacters } from "../utils/transformText";

export const InfosBlock = ({selected, setSelected, donneesSonsMarins, donnee, soundPlaying, setSoundPlaying, language}) => {
	const soundEl = useRef(null);

	useEffect(() => {
		soundPlaying ? soundEl.current.play() : soundEl.current.pause();
		soundEl.current.onended = () => setSoundPlaying(false);
	});

	const handleClickNext = () => {
		setSelected(
			selected + 1 <= donneesSonsMarins.length 
				? selected + 1 
				: 1
		);
		setSoundPlaying(true);
	}
	const handleClickPrevious = () => {
		setSelected(
			selected - 1 > 0 
				? selected - 1 
				: donneesSonsMarins.length
		);
		setSoundPlaying(true);
	}

  return (
		<section className='infos-block'>
			<header>
				<div className={`big-image ${noSpecialCharacters(donnee.name)}`}>
					<img src={donnee.img} alt={donnee.name} />
				</div>
				<h2 className="nom">{donnee.name}</h2>
				{donnee.portee && <div className="container-portee">
					<div className="portee">{language === "en" ? "Scope:" : <>Portée&nbsp;:</>} {donnee.portee}&thinsp;m</div>
				</div>}
				<button className="btn close" onClick={() => setSelected(null)}>
					<img src={svgClose} alt="retour" />
				</button>
			</header>
			<div className="container-audio-textes">
				<button className="btn sound" onClick={() => setSoundPlaying(!soundPlaying)}>
					<audio
						ref={soundEl}
						src={require(`../sons/${donnee.son}`)}
					/>
					<img src={soundPlaying ? svgPause : svgPlay} alt="retour" />
				</button>
				<div className="container-textes">
					<div className="textes">
						<div className="texte">{donnee.texte}</div>
						{donnee.plusLoin && <div className="plus-loin">
							<p><strong>{language === "en" ? "To go further:" : <>Pour aller plus loin&nbsp;:</>}</strong></p>
							<p>{donnee.plusLoin}</p>
						</div>}
					</div>
				</div>
			</div>
			<button
				className="btn previous"
				onClick={handleClickPrevious}
			>
				<img src={svgBack} alt="retour" />
			</button>
			<button
				className="btn next"
				onClick={handleClickNext}
			>
				<img src={svgBack} alt="suivant" style={{transform: "rotate(180deg)"}} />
			</button>
		</section>
	);

}

